import React from 'react';
import { UnitInput } from '@/views/components/inputs';
import { UnitSymbolSection } from '@/views/components/inputs/UnitInput';

interface TaxPercentageInputProps {
  id: string;
  label: string;
  value: number | undefined;
  onChange: (value?: number) => void;
  disabled?: boolean;
  placeholder?: string;
}

const TaxPercentageInput: React.FC<TaxPercentageInputProps> = ({ id, label, value, onChange, disabled = false, placeholder = '0' }) => (
  <div className="tax-input-row">
    <label htmlFor={id}>{label}</label>
    <UnitInput
      id={id}
      symbolSection={UnitSymbolSection.RIGHT}
      className="unit-input-v2"
      type="number"
      unitSymbol="%"
      min={0}
      max={100}
      value={value ?? ''}
      onValueChange={(val: string) => onChange(val ? Number(val) : undefined)}
      disabled={disabled}
      placeholder={placeholder}
    />
  </div>
);

export default TaxPercentageInput;
